import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { decrypt } from '../../../common/enc_dec';
import { course } from '../../../slices/courseSlice';
import CourseDetailsView from '../trainingReport/courseDetailsView';
import { financialReport_ } from '../../../slices/reportSlice';
import UsersEnrolled from './usersEnrolled';

const FinancialReport = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const _id = decrypt(queryParams.get("id"));
    const { id } = location?.state || {};
    const courseId = id || _id;

    useEffect(() => {
        if (courseId) {
            dispatch(course({ id: courseId }));
        }
    }, [dispatch, courseId]);

    return (
        <div className="content-page">
            <CourseDetailsView />

            <div className="card mt-3 shadow-sm">
                <div className="card-body">
                    <h5 className="card-title fw-semibold">👥 Financial Report - Users Enrolled</h5>
                    <p className="card-text text-muted">
                        <UsersEnrolled />
                    </p>
                </div>
            </div>
        </div>
    )
}

export default FinancialReport;